export default "__VITE_ASSET__DnsPSY$c__"